module.exports = __webpack_public_path__ + "static/img/avatar.a4f7728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar.png
// module id = zQrT
// module chunks = 12